// extracted by mini-css-extract-plugin
export default {"PfsArticles":"PFSArticlesIndex_PfsArticles__pbdXK","searchInput":"PFSArticlesIndex_searchInput__kOaak","searchIcon":"PFSArticlesIndex_searchIcon__LFvAk"};